/* ============================================================================
   PRESSROOM — CUSTOM "Your Art, Our Ink" davranisi (FAZ 2 Parti 2, spec 3.7)
   <pressroom-custom> web component.
   - Sahne gorunur olunca tasarim "tisorte basilir": .is-printed (dropzone'dan
     dusus + halftone-pop + ink-bleed kisa puls). Tek IntersectionObserver.
   - reduced-motion: hicbir animasyon kurma; tasarim onceden basili (CSS).

   Kurallar (CLAUDE.md + spec): hardcoded yok; ink-bleed puls suresi --d-base
   token'dan. Mobil: ayni davranis (tek tasarim) — perf icin ek is yok.
   ============================================================================ */
(function () {
  'use strict';

  if (!('customElements' in window)) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readToken(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }
  function toMs(token, fallbackMs) {
    if (!token) return fallbackMs;
    if (token.indexOf('ms') !== -1) return parseFloat(token);
    if (token.indexOf('s') !== -1) return parseFloat(token) * 1000;
    var n = parseFloat(token);
    return isNaN(n) ? fallbackMs : n;
  }

  customElements.define('pressroom-custom', class extends HTMLElement {
    connectedCallback() {
      this._scene = this.querySelector('[data-pr-custom-scene]');
      this._print = this.querySelector('[data-pr-custom-print]');
      if (!this._scene || !this._print) return;

      // reduced-motion: CSS zaten basili statik veriyor; medyayi da bas (halftone).
      if (REDUCED) {
        this._print.classList.add('is-printed');
        return;
      }

      this._bleedMs = toMs(readToken('--d-base'), 420);

      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(this._onIntersect.bind(this), {
          rootMargin: '0px 0px -12% 0px',
          threshold: 0.3
        });
        this._io.observe(this._scene);
      } else {
        this._print.classList.add('is-printed');
      }
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._bleedTimer) clearTimeout(this._bleedTimer);
    }

    _onIntersect(entries, obs) {
      if (entries[0].isIntersecting && !this._done) {
        this._done = true;
        obs.unobserve(this._scene);
        this._print.classList.add('is-printed');
        // ink-bleed kisa puls (primitive .is-bleeding), sonra geri al.
        this._print.classList.add('is-bleeding');
        var self = this;
        this._bleedTimer = setTimeout(function () {
          self._print.classList.remove('is-bleeding');
        }, this._bleedMs);
      }
    }
  });
})();
